module.exports = __webpack_public_path__ + "img/product-example-big.9b7ef3ff.svg";